function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { Observable } from "rxjs/Observable";
import flatten from "lodash/flatten";
import uniq from "lodash/uniq";
import "rxjs/add/operator/map";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/share";
import "rxjs/add/operator/catch";
// Generate a unique Id
export var uuid = function(a) {
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([
        1e7
    ] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
};
export var APISession = /*#__PURE__*/ function() {
    "use strict";
    function APISession() {
        var providers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var _this = this;
        var _Observable;
        _classCallCheck(this, APISession);
        this._sessionId = uuid();
        this._providers = providers;
        this._source = (_Observable = Observable).merge.apply(_Observable, _toConsumableArray(this._providers.map(function(p) {
            return p.getObservable();
        }))).filter(function(msg) {
            return msg.sessionId === _this._sessionId;
        }).share();
    }
    _createClass(APISession, [
        {
            key: "subscribe",
            value: function subscribe() {
                var channels = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], options = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                var cb, errFn;
                console.warn("You are using Extension API version 2 which is deprecated. You might want to update to version 3: https://confluence.create.at/display/CBOOK/API+Referenz");
                // We have to delay the execution until we returned the Promise.
                setTimeout(function() {
                    if (channels) {
                        _this._source.catch(function(err) {
                            if (errFn) {
                                errFn(err);
                            }
                        }).subscribe(function(x) {
                            if (!!x && cb) {
                                cb(x);
                            }
                        }, function(err) {
                            console.error(err);
                            if (errFn) {
                                errFn(err);
                            }
                        });
                        channels.forEach(function(c) {
                            return _this.write("sub", c, options);
                        });
                    } else {
                        var err = new Error("Channels should be truthy (Array)");
                        if (errFn) {
                            errFn(err);
                        }
                    }
                }, 5);
                return {
                    then: function then(f) {
                        cb = f;
                        return {
                            catch: function(fn) {
                                errFn = fn;
                            }
                        };
                    }
                };
            }
        },
        {
            /**
   * Ticket: #5835
   * We need the setTimeout to handle the for loop asyncronosly.
   * If not, the transactionId will be returned to late (Provider may finish before)
   */ key: "write",
            value: function write(channel, data, options) {
                var _this = this;
                if (!!channel && typeof channel === "string") {
                    var transactionId = uuid();
                    setTimeout(function() {
                        for(var index = 0; index < _this._providers.length; index++){
                            _this._providers[index].write(_this._sessionId, {
                                type: channel,
                                sessionId: _this._sessionId,
                                data: data,
                                options: options,
                                transactionId: transactionId
                            });
                        }
                    }, 1);
                    return transactionId;
                } else {
                    throw typeof channel !== "string" ? new TypeError("Channelname should be a String but is ".concat(typeof channel === "undefined" ? "undefined" : _typeof(channel))) : "Channelname should not be empty or null";
                }
            }
        }
    ]);
    return APISession;
}();
export var ExtensionAPI = /*#__PURE__*/ function() {
    "use strict";
    function ExtensionAPI() {
        var Providers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        _classCallCheck(this, ExtensionAPI);
        // Providers should be immuntable
        this._providers = Providers;
        this._sessions = [];
    }
    _createClass(ExtensionAPI, [
        {
            // sessionProviders are Providers specific for this Session and only this Session has access to them
            key: "createSession",
            value: function createSession() {
                var sessionProviders = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var session = new APISession(_toConsumableArray(this._providers).concat(_toConsumableArray(sessionProviders)));
                this._sessions.push(session);
                return session;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._providers.forEach(function(p) {
                    return p.release();
                });
                this._providers = [];
                this._sessions = [];
            }
        },
        {
            key: "reduxMiddleware",
            value: function reduxMiddleware(store, action) {
                return uniq(flatten(this._sessions.map(function(s) {
                    return s._providers.map(function(p) {
                        return p.reduxMiddleware(store, action, s._sessionId);
                    });
                })));
            }
        }
    ]);
    return ExtensionAPI;
}();
export default {
    expose: function expose() {
        var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, providers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if (!scope.ExtensionAPI2) {
            scope.ExtensionAPI2 = new ExtensionAPI(providers);
        }
        return scope;
    },
    remove: function remove(scope) {
        if (!scope) {
            throw new Error("You have to specify a valid scope to remove the API from eg. window");
        }
        scope.ExtensionAPI2.dispose();
        scope.ExtensionAPI2 = null;
        delete scope.ExtensionAPI2;
    },
    createExtensionMiddleware: function(scope) {
        return function(store) {
            return function(next) {
                return function(action) {
                    if (!scope) {
                        throw new Error("You have to specify a valid scope to remove the API from eg. window");
                    }
                    if (scope.ExtensionAPI2) {
                        scope.ExtensionAPI2.reduxMiddleware(store, action);
                    /* .forEach(a => next(a)); */ }
                    return next(action);
                };
            };
        };
    }
};
